import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SCRAPE_DATA } from '../data/scrapeData';
import { GLOBAL_COMPANY_INFO, getResizedImageUrl } from '../lib/cms';
import GalleryLightbox from '../components/GalleryLightbox';
import ContactForm from '../components/ContactForm';

export default function HomePage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const heroImage = 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg';

  const selectedProjects = [
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg',
      alt: 'Sort træhus med rødt tegltag og have',
      title: 'Træhus malet i sort',
      category: 'Udendørsprojekt'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240521-125720-scaled.jpg',
      alt: 'Moderne hvidt hus med stor grøn have',
      title: 'Moderne villa med nymalet facade',
      category: 'Facademaling'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240807-125724-scaled.jpg',
      alt: 'Mørkeblå trægarage med nymalet facade',
      title: 'Mørkeblå trægarage',
      category: 'Træværk'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt007.jpg',
      alt: 'Hvide dobbeltdøre med glasruder indendørs',
      title: 'Hvide dobbeltdøre med glasruder',
      category: 'Indendørsprojekt'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240327-161629-scaled.jpg',
      alt: 'Moderne køkken med geometrisk tapet',
      title: 'Køkken med geometrisk tapet',
      category: 'Tapetsering'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg',
      alt: 'Indendørs trappe med grøn gelænder og hvide vægge',
      title: 'Trappe med grønt gelænder',
      category: 'Indendørsprojekt'
    }
  ];

  const mainServices = [
    {
      title: 'Indendørs Projekter',
      desc: 'Professionelt indendørs malerarbejde med fokus på kvalitet og service. Maling af vægge, lofter, træværk, døre og dørkarme.',
      href: '/indendors-projekter',
      icon: 'fa-regular fa-paint-roller',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg'
    },
    {
      title: 'Udendørsprojekter',
      desc: 'Maling af træværk, vinduer og facader, der beskytter bygningen mod vejrets påvirkninger og giver et smukt, holdbart udseende.',
      href: '/udendors-projekter',
      icon: 'fa-regular fa-house-chimney-window',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20250812-144318-scaled.jpg'
    },
    {
      title: 'Maler i Nørresundby',
      desc: 'Lokal maler til både indvendigt og udvendigt malerarbejde i Nørresundby, Lindholm og omegn for private og erhverv.',
      href: '/maler-norresundby',
      icon: 'fa-regular fa-location-dot',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240807-125724-scaled.jpg'
    },
    {
      title: 'Maler i Brønderslev',
      desc: 'Flot og holdbart malerarbejde med fokus på kvalitet og detalje. Din lokale malermester i Brønderslev med 20 års erfaring.',
      href: '/maler-bronderslev',
      icon: 'fa-regular fa-brush',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112222-scaled.jpg'
    },
    {
      title: 'Maler i Støvring',
      desc: 'Kvalitet, ærlig rådgivning og flotte resultater i Støvring. Vi hjælper med alt fra enkeltstående rum til hele huse.',
      href: '/maler-stovring',
      icon: 'fa-regular fa-award',
      image: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240527-112728-scaled.jpg'
    }
  ];

  const advantages = [
    {
      title: '20 års malererfaring',
      desc: 'Med to årtier i branchen er du sikret faglig dygtighed, grundigt forarbejde og holdbare løsninger.',
      icon: 'fa-regular fa-user-check'
    },
    {
      title: 'Venlig & personlig service',
      desc: 'Du møder altid en frisk og imødekommende fagmand, der lytter til dine ønsker og lader din drøm gå i opfyldelse.',
      icon: 'fa-regular fa-comments'
    },
    {
      title: 'Lokal tilstedeværelse',
      desc: 'Med udgangspunkt i Aalborg kører vi primært i Nørresundby, Brønderslev og Støvring, men hjælper i hele landet.',
      icon: 'fa-regular fa-map-location-dot'
    },
    {
      title: 'Aftaler der holder',
      desc: 'Tydelig rådgivning, realistiske tidsplaner og gennemskuelige priser – uden ubehagelige overraskelser.',
      icon: 'fa-regular fa-handshake'
    }
  ];

  const reviews3Byggetilbud = [
    {
      name: 'Dorthe K.',
      rating: 5,
      date: 'Verificeret kunde på 3Byggetilbud.dk',
      text: 'Malerarbejdet blev gjort både hurtigt og meget omhyggeligt. Carsten er en meget behagelig og yderst fleksibel person at have i huset. Jeg giver ham mine varmeste anbefalinger.'
    },
    {
      name: 'Susanne K.',
      rating: 5,
      date: 'Verificeret kunde på 3Byggetilbud.dk',
      text: 'En utrolig sympatisk mand, godt arbejde og hurtig. Kan varmt anbefales.'
    },
    {
      name: 'Nicolai K.',
      rating: 5,
      date: 'Verificeret kunde på 3Byggetilbud.dk',
      text: 'Har kun gode ord og ros at sige om Carsten som person og hans arbejde. Stor anbefaling herfra!'
    },
    {
      name: 'Britta M.',
      rating: 5,
      date: 'Verificeret kunde på 3Byggetilbud.dk',
      text: 'Professionelt, godt gedigent arbejde. Overholder alle aftaler og leverer altid høj kvalitet.'
    }
  ];

  return (
    <div className="bg-[#F8FAFC]">
      {/* HERO SECTION */}
      <section className="relative bg-[#1D352E] text-white pt-32 sm:pt-36 md:pt-44 pb-20 md:pb-32 overflow-hidden">
        {/* Background Image Overlay - More Transparent */}
        <div className="absolute inset-0 z-0 opacity-45">
          <img
            src={getResizedImageUrl(heroImage, 1800, 80)}
            alt="Malerarbejde udført af Maler Carsten Janum ApS"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/70 via-slate-950/45 to-slate-950/25 z-0" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-6">

            {/* BINDING SCRAPE PRIMARY HEADING VERBATIM */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
              {SCRAPE_DATA.index.mainHeading}
            </h1>

            <p className="text-lg sm:text-xl text-gray-200 leading-relaxed font-normal">
              {SCRAPE_DATA.index.paragraphs[0]}
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-3 px-7 py-4 text-base font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 text-center"
              >
                <span>Få et uforpligtende tilbud</span>
                <i className="fa-solid fa-arrow-right text-xs" />
              </Link>

              <a
                href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
                className="inline-flex items-center justify-center gap-3 px-7 py-4 text-base font-semibold text-white bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl transition-all duration-200 text-center nowrap-contact"
              >
                <i className="fa-solid fa-phone text-white" />
                <span className="nowrap-contact">Ring til Carsten: {GLOBAL_COMPANY_INFO.phone}</span>
              </a>
            </div>

            {/* 3Byggetilbud Trust Badge */}
            <div className="pt-2">
              <a
                href="https://www.3byggetilbud.dk/leverandoer/maler-carsten-janum-aps/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 sm:gap-3 px-4 py-2.5 bg-black/40 hover:bg-black/60 border border-amber-400/30 rounded-full text-white text-xs sm:text-sm font-medium transition-all group backdrop-blur-sm"
              >
                <div className="flex items-center text-amber-400 gap-0.5 text-sm shrink-0">
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                </div>
                <span className="font-bold text-amber-300">4,9 / 5</span>
                <span className="text-gray-200 text-xs sm:text-sm">(18 anmeldelser på 3Byggetilbud.dk)</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-gray-300 group-hover:text-white transition-colors ml-0.5" />
              </a>
            </div>

            {/* Quick highlights */}
            <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 pt-8 border-t border-white/10 text-xs sm:text-sm text-gray-300">
              {SCRAPE_DATA.index.bullets.map((bullet, idx) => (
                <div key={idx} className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-white" />
                  <span>{bullet}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* OVERLAPPING QUICK SERVICE CARDS (Divi Roofing-2 Inspired Structural Layer) */}
      <div className="-mt-12 md:-mt-16 relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/indendors-projekter"
            className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-all duration-300 group flex flex-col justify-between"
          >
            <div>
              <div className="w-12 h-12 rounded-xl bg-[#65237e] text-white flex items-center justify-center text-xl shadow-md mb-4 group-hover:scale-105 transition-transform">
                <i className="fa-regular fa-paint-roller" />
              </div>
              <h3 className="text-xl font-bold text-[#1D352E] group-hover:text-[#65237e] transition-colors">
                Indendørs Malerarbejde
              </h3>
              <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                Maling af vægge, lofter, døre og paneler med fokus på grundigt forarbejde og flotte overflader.
              </p>
            </div>
            <div className="pt-4 flex items-center text-xs font-semibold text-[#65237e] group-hover:translate-x-1 transition-transform">
              <span>Læs mere om indendørs &rarr;</span>
            </div>
          </Link>

          <Link
            to="/udendors-projekter"
            className="bg-white rounded-2xl p-6 shadow-xl border border-slate-100 hover:shadow-2xl transition-all duration-300 group flex flex-col justify-between"
          >
            <div>
              <div className="w-12 h-12 rounded-xl bg-[#65237e] text-white flex items-center justify-center text-xl shadow-md mb-4 group-hover:scale-105 transition-transform">
                <i className="fa-regular fa-house-chimney-window" />
              </div>
              <h3 className="text-xl font-bold text-[#1D352E] group-hover:text-[#65237e] transition-colors">
                Udendørs & Facader
              </h3>
              <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                Beskyttende malerarbejde på træværk, vinduer og facader, der modstår det nordjyske vind og vejr.
              </p>
            </div>
            <div className="pt-4 flex items-center text-xs font-semibold text-[#65237e] group-hover:translate-x-1 transition-transform">
              <span>Læs mere om udendørs &rarr;</span>
            </div>
          </Link>

          <Link
            to="/kontakt"
            className="bg-[#1D352E] text-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 group flex flex-col justify-between border border-white/10"
          >
            <div>
              <div className="w-12 h-12 rounded-xl bg-[#65237e] text-white flex items-center justify-center text-xl shadow-md mb-4 group-hover:scale-105 transition-transform">
                <i className="fa-regular fa-[#1D352E] fa-calculator" />
              </div>
              <h3 className="text-xl font-bold text-white group-hover:text-[#65237e] transition-colors">
                Gratis & Uforpligtende Tilbud
              </h3>
              <p className="text-gray-300 text-sm mt-2 leading-relaxed">
                Send en besked eller ring direkte til Carsten for rådgivning og et prisoverslag på din opgave.
              </p>
            </div>
            <div className="pt-4 flex items-center text-xs font-semibold text-white group-hover:translate-x-1 transition-transform">
              <span>Få tilbud nu &rarr;</span>
            </div>
          </Link>
        </div>
      </div>

      {/* INTRODUCTION SECTION */}
      <section className="py-16 sm:py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch">
            
            {/* Left Image Showcase */}
            <div className="lg:col-span-5 relative flex flex-col h-full">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-white flex-1 h-full min-h-[360px]">
                <img
                  src={getResizedImageUrl('https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg', 800, 85)}
                  alt="Maler Carsten Janum håndværk"
                  className="w-full h-full object-cover min-h-[360px]"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#1D352E] text-white p-6 rounded-2xl shadow-xl hidden sm:block max-w-xs border border-white/10 z-10">
                <div className="text-3xl font-extrabold text-white">20+ år</div>
                <div className="text-xs text-gray-300 font-medium mt-1">Erfaring med professionelt malerarbejde i Nordjylland</div>
              </div>
            </div>

            {/* Right Copy */}
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 text-[#65237e] text-sm font-semibold tracking-wider uppercase">
                <i className="fa-solid fa-house-user" />
                <span>Velkommen til Maler Carsten Janum ApS</span>
              </div>

              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1D352E] leading-tight">
                {SCRAPE_DATA.index.introSubhead}
              </h2>

              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>{SCRAPE_DATA.index.paragraphs[1]}</p>
                <p>{SCRAPE_DATA.index.paragraphs[2]}</p>
                <p>{SCRAPE_DATA.index.paragraphs[3]}</p>
              </div>

              <div className="pt-2 flex flex-wrap items-center gap-4">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-lg transition-colors shadow-sm"
                >
                  <span>Kontakt Carsten i dag</span>
                  <i className="fa-solid fa-arrow-right text-xs" />
                </Link>
                <Link
                  to="/om-os"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-[#1D352E] bg-[#F1F5F9] hover:bg-white border border-[#1D352E]/10 rounded-lg transition-colors"
                >
                  Læs mere om os
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section className="py-16 sm:py-24 bg-[#F1F5F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-3">
            <span className="text-[#65237e] text-xs sm:text-sm font-semibold tracking-wider uppercase">
              Vores Ydelser
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1D352E]">
              Hvad kan vi hjælpe dig med?
            </h2>
            <p className="text-gray-600 text-base">
              Vi løser alle typer maleropgaver for både private boligejere, erhverv og boligforeninger med faglig omhu.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-6 gap-8">
            {mainServices.map((service, index) => {
              const total = mainServices.length;
              const remainderLg = total % 3;
              const lastRowLgCount = remainderLg === 0 ? 3 : remainderLg;
              const firstLastRowLgIndex = total - lastRowLgCount;

              const remainderMd = total % 2;
              const lastRowMdCount = remainderMd === 0 ? 2 : remainderMd;
              const firstLastRowMdIndex = total - lastRowMdCount;

              let colSpan = "";
              // lg screen rules:
              if (index >= firstLastRowLgIndex) {
                if (lastRowLgCount === 1) colSpan += " lg:col-span-6";
                else if (lastRowLgCount === 2) colSpan += " lg:col-span-3";
                else colSpan += " lg:col-span-2";
              } else {
                colSpan += " lg:col-span-2";
              }

              // md screen rules:
              if (index >= firstLastRowMdIndex) {
                if (lastRowMdCount === 1) colSpan += " md:col-span-6";
                else colSpan += " md:col-span-3";
              } else {
                colSpan += " md:col-span-3";
              }

              return (
                <Link
                  key={index}
                  to={service.href}
                  className={`group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 flex flex-col cursor-pointer ${colSpan}`}
                >
                  <div className="relative h-48 overflow-hidden bg-gray-100">
                    <img
                      src={getResizedImageUrl(service.image, 600, 80)}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity" />
                    <div className="absolute bottom-3 left-4 w-10 h-10 rounded-lg bg-[#1D352E] text-white flex items-center justify-center text-lg shadow-md group-hover:bg-[#65237e] transition-colors">
                      <i className={service.icon} />
                    </div>
                  </div>

                  <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
                    <div>
                      <h3 className="text-xl font-bold text-[#1D352E] group-hover:text-[#65237e] transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                        {service.desc}
                      </p>
                    </div>

                    <div className="pt-2 flex items-center text-xs font-semibold text-[#65237e] group-hover:translate-x-1 transition-transform">
                      <span>Læs mere og se eksempler</span>
                      <i className="fa-solid fa-arrow-right ml-2" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* ABOUT CARSTEN SECTION */}
      <section className="py-16 sm:py-24 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#1D352E] rounded-3xl p-8 sm:p-12 text-white relative overflow-hidden shadow-2xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
              
              <div className="lg:col-span-8 space-y-6">
                <div className="inline-flex items-center gap-2 px-3.5 py-1.5 bg-white/10 rounded-full text-xs sm:text-sm font-medium text-white border border-white/15">
                  <i className="fa-solid fa-user-gear text-white" />
                  <span>Mød Carsten Janum</span>
                </div>

                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
                  Lokal og jordnær malermester med 20 års fagerfaring
                </h2>

                <p className="text-gray-200 text-base leading-relaxed">
                  Hos Maler Carsten Janum ApS handler det ikke bare om at påføre maling – det handler om at skabe tryghed, levere et pænt og holdbart resultat og holde alle indgåede aftaler. Som selvstændig maler lytter jeg altid direkte til mine kunders ønsker.
                </p>

                <div className="flex flex-wrap gap-4 pt-2">
                  <a
                    href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
                    className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl transition-colors shadow-md nowrap-contact"
                  >
                    <i className="fa-solid fa-phone" />
                    <span className="nowrap-contact">Ring direkte: {GLOBAL_COMPANY_INFO.phone}</span>
                  </a>
                  <Link
                    to="/om-os"
                    className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors"
                  >
                    Se profilsiden Om os
                  </Link>
                </div>
              </div>

              <div className="lg:col-span-4 flex justify-center">
                <div className="relative w-full max-w-xs rounded-2xl overflow-hidden border-4 border-white/20 shadow-2xl">
                  <img
                    src={getResizedImageUrl('https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt004.jpg', 600, 85)}
                    alt="Maler Carsten Janum præsentation"
                    className="w-full h-80 object-cover"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* 3BYGGETILBUD REVIEWS & RECOMMENDATIONS SECTION */}
      <section id="anmeldelser" className="py-16 sm:py-24 bg-white border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header & Overall Score Badge */}
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 mb-16 pb-10 border-b border-slate-100">
            <div className="space-y-3 max-w-2xl">
              <span className="inline-flex items-center gap-2 text-[#65237e] text-xs sm:text-sm font-semibold tracking-wider uppercase">
                <i className="fa-solid fa-star text-amber-500" />
                <span>Kundeanmeldelser & Tillid</span>
              </span>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#1D352E]">
                Anbefalinger fra glade kunder
              </h2>
              <p className="text-gray-600 text-base leading-relaxed">
                Tilhfredse kunder er vores bedste resultat. Se hvad boligejere og bygherrer skriver om samarbejdet med Maler Carsten Janum ApS på 3Byggetilbud.dk.
              </p>
            </div>

            {/* Rating Summary Box */}
            <div className="bg-[#1D352E] text-white p-6 sm:p-8 rounded-3xl shadow-xl flex flex-col sm:flex-row items-center gap-6 shrink-0 border border-white/10">
              <div className="text-center sm:text-left">
                <div className="text-4xl sm:text-5xl font-black text-amber-400 flex items-center justify-center sm:justify-start gap-2">
                  <span>4,9</span>
                  <span className="text-xl text-gray-300 font-normal">/ 5.0</span>
                </div>
                <div className="flex items-center justify-center sm:justify-start text-amber-400 gap-1 mt-2 text-lg">
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                </div>
              </div>

              <div className="border-t sm:border-t-0 sm:border-l border-white/20 pt-4 sm:pt-0 sm:pl-6 text-center sm:text-left space-y-1">
                <div className="text-sm font-bold text-white">18 verificerede anmeldelser</div>
                <p className="text-xs text-gray-300">Profil på 3Byggetilbud.dk</p>
                <a
                  href="https://www.3byggetilbud.dk/leverandoer/maler-carsten-janum-aps/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-300 hover:text-amber-200 transition-colors pt-1"
                >
                  <span>Læs alle anmeldelser</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
                </a>
              </div>
            </div>
          </div>

          {/* Customer Testimonial Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {reviews3Byggetilbud.map((rev, idx) => (
              <div
                key={idx}
                className="bg-[#F8FAFC] rounded-2xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
              >
                <div className="space-y-4">
                  {/* Rating Stars & Quote Icon */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-amber-400 text-sm gap-1">
                      {[...Array(rev.rating)].map((_, i) => (
                        <i key={i} className="fa-solid fa-star" />
                      ))}
                    </div>
                    <i className="fa-solid fa-quote-right text-slate-300 text-xl" />
                  </div>

                  {/* Quote Text */}
                  <p className="text-gray-700 text-sm leading-relaxed italic">
                    "{rev.text}"
                  </p>
                </div>

                {/* Reviewer Info */}
                <div className="pt-6 mt-6 border-t border-slate-200/80 flex items-center justify-between">
                  <div>
                    <h4 className="text-sm font-bold text-[#1D352E]">{rev.name}</h4>
                    <span className="text-[11px] text-emerald-700 font-medium flex items-center gap-1 mt-0.5">
                      <i className="fa-solid fa-circle-check text-[10px]" />
                      <span>{rev.date}</span>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Link to 3Byggetilbud */}
          <div className="mt-12 text-center">
            <a
              href="https://www.3byggetilbud.dk/leverandoer/maler-carsten-janum-aps/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold text-white bg-[#1D352E] hover:bg-[#162a24] rounded-xl shadow-md hover:shadow-lg transition-all"
            >
              <i className="fa-solid fa-award text-amber-400 text-base" />
              <span>Se Maler Carsten Janum ApS på 3Byggetilbud.dk</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" />
            </a>
          </div>

        </div>
      </section>

      {/* FEATURED PROJECTS GRID */}
      <section className="py-16 sm:py-24 bg-[#F1F5F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
            <div>
              <span className="text-[#65237e] text-xs sm:text-sm font-semibold tracking-wider uppercase">
                Referencer & Galleri
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#1D352E] mt-1">
                Udvalgte projekter
              </h2>
            </div>
            <Link
              to="/projekter"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#1D352E] hover:text-[#65237e] transition-colors"
            >
              <span>Se alle projekter i det store galleri</span>
              <i className="fa-solid fa-arrow-right" />
            </Link>
          </div>

          {/* Project Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {selectedProjects.map((project, idx) => (
              <div
                key={idx}
                onClick={() => setLightboxIndex(idx)}
                className="group relative rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 cursor-pointer"
              >
                <div className="aspect-4/3 overflow-hidden bg-gray-100">
                  <img
                    src={getResizedImageUrl(project.src, 600, 80)}
                    alt={project.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ADVANTAGES SECTION - Restyled based on "Counter" design reference */}
      <section className="relative py-20 sm:py-28 overflow-hidden bg-slate-900 text-white">
        {/* Background Image with transparent dark overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src={getResizedImageUrl(heroImage, 1800, 75)}
            alt="Maler Carsten Janum baggrund"
            className="w-full h-full object-cover opacity-45"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-slate-950/50 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Centered Constrained Header Block */}
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white/10 text-white text-xs sm:text-sm font-semibold tracking-wider uppercase border border-white/15">
              Hvorfor vælge os
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight leading-tight">
              Fordele ved Maler Carsten Janum ApS
            </h2>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              Vi kombinerer faglige traditioner med moderne teknikker og personlig opmærksomhed.
            </p>
          </div>

          {/* 4-Column Grid of Primary Accent Stat/Advantage Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {advantages.map((adv, idx) => (
              <div
                key={idx}
                className="bg-[#65237e] text-white rounded-3xl p-8 shadow-2xl flex flex-col items-center text-center justify-between border border-white/10 hover:scale-[1.02] transition-transform duration-300"
              >
                {/* Top Icon */}
                <div className="w-16 h-16 rounded-2xl bg-white/15 text-white flex items-center justify-center text-2xl mb-6 shadow-inner">
                  <i className={adv.icon} />
                </div>

                {/* Middle Label & Description */}
                <div className="space-y-3 flex-1 flex flex-col items-center justify-center">
                  <h3 className="text-xl font-bold text-white tracking-tight">
                    {adv.title}
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed font-normal">
                    {adv.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BOOKING / QUICK QUOTE FORM SECTION (Divi Roofing-2 Inspired) */}
      <section className="py-16 sm:py-24 bg-[#F1F5F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Form Column */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

            {/* Feature Information Card */}
            <div className="lg:col-span-5 space-y-6">
              <div className="inline-flex items-center gap-2 text-[#65237e] text-sm font-semibold tracking-wider uppercase">
                <i className="fa-solid fa-[#1D352E] fa-clipboard-check" />
                <span>Uforpligtende Rådgivning</span>
              </div>
              
              <h2 className="text-3xl font-bold text-[#1D352E] leading-tight">
                Lad os hjælpe dig med at realisere dit næste malerprojekt
              </h2>

              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                Uanset om du skal have malet et enkelt rum, hele huset indvendigt eller træværket og facaden udvendigt, står Maler Carsten Janum ApS klar med kompetent rådgivning og gennemskuelige priser.
              </p>

              <div className="space-y-4 pt-2">
                <div className="flex items-start gap-4 p-4 rounded-xl bg-white border border-slate-200/80 shadow-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#65237e] text-white flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-phone" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#1D352E]">Direkte telefonkontakt</h4>
                    <p className="text-xs text-gray-600 mt-0.5">Ring til Carsten på <a href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`} className="text-[#65237e] font-semibold underline nowrap-contact">{GLOBAL_COMPANY_INFO.phone}</a> for en hurtig snak.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl bg-white border border-slate-200/80 shadow-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#1D352E] text-white flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-envelope" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#1D352E]">Skriftlig besked eller e-mail</h4>
                    <p className="text-xs text-gray-600 mt-0.5">Send os en besked via formularen eller skriv til <a href={`mailto:${GLOBAL_COMPANY_INFO.email}`} className="text-[#65237e] font-semibold underline nowrap-contact">{GLOBAL_COMPANY_INFO.email}</a>.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl bg-white border border-slate-200/80 shadow-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#65237e] text-white flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-map-location-dot" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#1D352E]">Lokal maler i Aalborg & Omegn</h4>
                    <p className="text-xs text-gray-600 mt-0.5">Vi udfører opgaver i Aalborg, Nørresundby, Brønderslev, Støvring samt i hele landet.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <GalleryLightbox
        images={selectedProjects}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : selectedProjects.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < selectedProjects.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
